import { rgba } from 'polished'
import styled, { css } from 'styled-components'

import { FireButton } from '@nx/fire/button'
import { Body } from '@nx/fire/typography'

export const StyledButtonContainer = styled.div`
  display: grid;
  width: 100%;
`

export const StyledBiddingButton = styled.button<{
  $animationDuration: number
  $variant: string
  $pauseAnimation: boolean
}>`
  ${({ theme, $animationDuration, $variant, $pauseAnimation }) => css`
    ${theme.typography.body.M}
    ${theme.fontStyles.sourceSans.medium}

    cursor: pointer;
    background-color: ${rgba(theme.colours.status.error, 0.1)};
    color: ${theme.colours.status.error};
    position: relative;
    width: 100%;
    padding: ${$variant === 'compact' ? 4 : 8}px;
    text-align: center;
    border: 0;
    border-radius: 5px;

    &:hover {
      text-decoration: underline;
    }

    @keyframes background-fill {
      0% {
        width: 0;
      }

      100% {
        width: 100%;
      }
    }

    &::after {
      content: '';
      position: absolute;
      height: 100%;
      top: 0;
      left: 0;
      border-radius: 5px;
      background-color: ${rgba(theme.colours.status.error, 0.2)};
      animation: ${$animationDuration}s linear 0s 1 background-fill;

      ${$pauseAnimation &&
      css`
        animation-play-state: paused;
      `}
    }
  `}
`

export const StyledInitialBiddingButton = styled(FireButton)<{
  $variant: string
}>`
  ${({ theme }) => theme.fontStyles.sourceSans.medium}

  ${({ theme, $variant }) =>
    $variant === 'compact' &&
    css`
      ${theme.typography.body.M}
      ${theme.fontStyles.sourceSans.medium}
      color: ${theme.colours.primary.primary};
      text-decoration: underline;

      &:hover {
        color: ${theme.colours.primary.black} !important;
      }
    `}
`

export const StyledBody = styled(Body)`
  margin: 5px 0 0;
`
